import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React, { useEffect, useRef } from "react";
import { arrayIsNotEmpty } from "../../../../utils";

Highcharts.setOptions({
    lang: {
        decimalPoint: ".",
        thousandsSep: ",",
    },
});

const options = {
    accessibility: {
        enabled: false,
    },
    chart: {
        style: {
            fontFamily: "Roboto",
        },
        borderWidth: 0,
        plotBorderColor: "#98DDE1",
        plotBorderWidth: 1,
    },
    title: {
        text: "",
    },
    credits: {
        enabled: false,
    },
    exporting: {
        enabled: true,
    },
    legend: {
        enabled: false,
        backgroundColor:
            Highcharts.defaultOptions.legend.backgroundColor || // theme
            "rgba(255,255,255,0.25)",
    },
    xAxis: {
        lineColor: "#98DDE1",
        lineWidth: 1,
        tickWidth: 1,
        tickColor: "#98DDE1",
        tickmarkPlacement: "on",
        crosshair: {
            width: 1,
            color: "#cccccc",
        },
        type: "category",
        labels: {
            style: {
                fontFamily: "Roboto",
                color: "#33475B",
                fontWeight: 400,
                fontSize: "16px",
                fontStyle: "normal",
                lineHeight: "19px",
            },
        },
        title: {
            text: "",
        },
        scrollbar: {
            enabled: false,
        },
    },

    tooltip: {
        headerFormat: `<div style="padding: 8px 8px 8px 0;box-shadow:0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);border-radius: 1rem;"><table style="color:#33475B;">`,
        pointFormatter: function () {
            let color = "#eeeeee";

            try {
                color = this.color?.stops[0][1];
            } catch (error) {
                console.log(error);
            }

            return (
                '<tr><td><div style="display:flex;align-items:center;padding:4px 0;"><span style="display:inline-block;background-color:' +
                (typeof this.color == "object" ? color : this.color) +
                ';width:7px;height:28px;border-radius:0 7px 7px 0"></span><span style="color:#32A6AE;padding-left:8px;font-size:12px">' +
                this.series.name +
                '</span></div></td><td style="padding-left:16px;font-size:14px">' +
                this.y +
                (this.series.name.includes("%") ? "%" : "") +
                "</td></tr>"
            );
        },
        footerFormat: "</table></div>",
        positioner: function (t1, t2, point) {
            return {
                x:
                    point.plotX + t1 > this.chart.plotWidth
                        ? point.plotX - t1 / 2
                        : point.plotX,
                y: this.chart.plotHeight - t2,
            };
        },
        // hideDelay: 200000,
        borderWidth: 0,
        padding: 0,
        margin: 0,
        borderRadius: 16,
        backgroundColor: "white",
        zIndex: -1,
        shadow: false,
        shared: true,
        useHTML: true,
    },
    plotOptions: {
        series: {
            connectNulls: false,
            borderRadius: "3",
            //borderWidth: 2,
            //borderColor: "#E4D6F5",
        },
        spline: {
            lineWidth: 3,
            marker: {
                enabled: false,
            },
        },
    },
    series: [],
};

// eslint-disable-next-line
const GeneralChart = ({
    // eslint-disable-next-line
    series = [],
    // eslint-disable-next-line
    showLegends = false,
    // eslint-disable-next-line
    xAxisCategories = [],
    yAxis = [],
}) => {
    const chartRef = useRef(null);

    useEffect(() => {
        if (series && series.length > 0)
            if (chartRef.current) {
                series.forEach((s) => {
                    let d = [];
                    xAxisCategories.forEach((c) => {
                        const f = arrayIsNotEmpty(s.dataPoints) ? s.dataPoints.find((x) => x.label === c) : undefined;
                        d.push({ label: c, y: f ? f.y : null });
                    });
                    chartRef.current.chart.addSeries({ ...s, data: d });
                });

                chartRef.current.chart.xAxis[0].setCategories([...xAxisCategories]);
                if (showLegends)
                    chartRef.current.chart.legend.update({
                        enabled: true,
                        align: "right",
                        verticalAlign: "middle",
                        layout: "vertical",
                    });
                else {
                    chartRef.current.chart.legend.update({
                        enabled: false,
                    });
                }
            }
    }, [series, xAxisCategories, showLegends]);

    options.yAxis = yAxis;

    return (
        <div className="chartContainer">
            <HighchartsReact
                highcharts={Highcharts}
                allowChartUpdate={true}
                immutable={false}
                updateArgs={[true, true, true]}
                containerProps={{ className: "chartContainer" }}
                ref={chartRef}
                options={options}
            />
        </div>
    );
};

export default GeneralChart;
